import script from "./overdueAmountTypeListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./overdueAmountTypeListView.vue?vue&type=script&lang=ts&setup=true"

import "./overdueAmountTypeListView.vue?vue&type=style&index=0&id=cfc40dec&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfc40dec"]])

export default __exports__